import styled from 'styled-components/macro'
import Grid from '@material-ui/core/Grid'

const UniqueStartersWrapper = styled(Grid)``

export default UniqueStartersWrapper
